import React, { useState } from "react";

import { Box, Typography, Alert, Collapse, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import LogoutIcon from "@mui/icons-material/Logout";
import { cnpjMask } from "../../../utils/mask.util";

import useStyles from "./authn-register-pc-style";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import RequestService from "../../../services/request.service";
import EnvService from "../../../services/env.service";

import { removeCookie } from "../../../utils/cookie.util";
import { ID_COOKIE_BB, ID_COOKIE_GAS } from "../../../constants";
import UrlService from "../../../services/url.service";
import { getResponseErrorMessage } from "../../../utils/error.util";

const POST_MACHINE_NAME = "user/cadastrar-apelido";

function RegisterPC(props) {
  const clientInfo = props.location.state;

  const [success, setSuccess] = useState(false);
  const successMessage =
    "Nome cadastrado! Solicite a liberação ao Administrador de Segurança.";
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [computerName, setComputerName] = useState("");
  const { REACT_APP_OAUTH_APW_ROUTE_URL } = EnvService.getEnv();
  const redirectAppUrl = UrlService.getQueryString("redirect_app_url");

  const onChangeHandler = (event) => {
    setComputerName(event.target.value);
  };

  const submitValue = async () => {
    setError(false);
    const computerInfo = {
      apelido: computerName,
      codCliente: clientInfo.id,
    };

    try {
      await RequestService.post(
        `${REACT_APP_OAUTH_APW_ROUTE_URL}/${POST_MACHINE_NAME}?redirect_app_url=${redirectAppUrl}`,
        computerInfo
      );
      setSuccess(true);
    } catch (e) {
      const message = getResponseErrorMessage(e);
      setErrorMessage(message);
      setError(true);
      console.log(message);
    }
  };

  function deleteAllCookies() {
    removeCookie(ID_COOKIE_BB);
    removeCookie(ID_COOKIE_GAS);
    setTimeout(() => {
      window.location.href = redirectAppUrl;
    }, 2000);
  }

  const styles = useStyles();
  return (
    <Box className={styles.root}>
      <Box className={styles.fullWidth}>
        <Box className={styles.rootHeader}>
          <span
            className={styles.logoArea}
            onClick={() => {
              window.location = "";
            }}
            data-testid="area-click"
          >
            <img
              src="/images/bb-logo.svg"
              className={styles.logo}
              alt="Logo Banco do Brasil"
            />
            <Box component="span" className={styles.logoText}>
              Banco do Brasil
            </Box>
          </span>
          <div
            style={{
              margin: "2px 0 0 10px",
              right: "14px",
              position: "absolute",
            }}
          >
            <button
              className={styles.clearButton1}
              onClick={() => deleteAllCookies()}
            >
              <LogoutIcon fontSize="large" />
            </button>
          </div>
        </Box>
      </Box>
      <div style={{ margin: "10px 0 0 10px" }}>
        <button className={styles.clearButton} onClick={props.history.goBack}>
          <ArrowBackIcon fontSize="large"></ArrowBackIcon>
        </button>
      </div>
      <div style={{ margin: "10px" }}>
        <Collapse in={error}>
          <Alert
            variant="filled"
            severity="error"
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => {
                  setError(false);
                }}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
            sx={{ mb: 2 }}
          >
            {errorMessage}
          </Alert>
        </Collapse>
        <Collapse in={success}>
          <Alert
            variant="filled"
            severity="success"
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => {
                  setSuccess(false);
                }}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
            sx={{ mb: 2 }}
          >
            {successMessage}
          </Alert>
        </Collapse>
      </div>
      <dls-card style={{ margin: "10px", maxWidth: "480px" }}>
        <dls-card-header>
          <Typography variant="h3">
            <b>Cadastrar Computador</b>
          </Typography>
        </dls-card-header>
        <dls-card-body>
          <Typography variant="h4">
            <b>Relacionamento selecionado</b>
          </Typography>
          <div style={{ margin: "20px 0 20px 0" }}>
            <dls-avatar
              name={clientInfo.empresa}
              description={"CNPJ: " + cnpjMask(clientInfo.cnpj)}
              noBorder=""
            />
          </div>
          <Typography variant="h3">
            <b>Qual o nome (apelido) para este computador?</b>
          </Typography>
          <input
            className={styles.input}
            style={{ flex: 1, margin: "15px 0 15px 0" }}
            placeholder="Informe um apelido..."
            value={computerName}
            onChange={onChangeHandler}
          />
        </dls-card-body>
        <dls-card-footer>
          <div></div>
          <dls-button size="regular" color="primary" onClick={submitValue}>
            Cadastrar
          </dls-button>
        </dls-card-footer>
      </dls-card>
    </Box>
  );
}

export default RegisterPC;
